"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
var _consumerJourney = _interopRequireDefault(require("@svb/svbbranding/dist/assets/images/consumer-journey.svg"));
var _imageHeaderConsumer = _interopRequireDefault(require("@svb/svbbranding/dist/assets/images/image-header-consumer.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Global components
 * By Bhargav Shivaprasad <bshivaprasad@svb.com> (www.svb.com)
 * Summary
 * This component renders an SVB API Consumer Header
 */

/**
 * SVB API Consumer Header
 * @param title - title for the header
 * @param description - description for the header 
 * @returns Consumer header component
 */

const SVBConsumerHeader = props => {
  var _props$title, _props$description, _props$titleStyle, _props$breadcrumbText;
  const {
    showIcon = true,
    showImage = true,
    showBreadcrumbs = false
  } = props;
  const title = (_props$title = props === null || props === void 0 ? void 0 : props.title) !== null && _props$title !== void 0 ? _props$title : "";
  const description = (_props$description = props === null || props === void 0 ? void 0 : props.description) !== null && _props$description !== void 0 ? _props$description : "";
  const titleStyle = (_props$titleStyle = props === null || props === void 0 ? void 0 : props.titleStyle) !== null && _props$titleStyle !== void 0 ? _props$titleStyle : "";
  const breadcrumbText = (_props$breadcrumbText = props === null || props === void 0 ? void 0 : props.breadcrumbText) !== null && _props$breadcrumbText !== void 0 ? _props$breadcrumbText : "";
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col pt-4 api-consumer-header-bg"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, showBreadcrumbs && /*#__PURE__*/_react.default.createElement("p", {
    className: "paragraph small mb-1 " + titleStyle
  }, breadcrumbText), /*#__PURE__*/_react.default.createElement("h1", {
    className: "heading-xxlarge pb-2 api-consumer-header-font-bg " + titleStyle
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "api-consumer-header-title-highlight"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "mb-3"
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "sub-heading font-medium-small api-consumer-header-font-other-bg mb-4 font-family-roboto"
  }, description), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, showIcon && /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _consumerJourney.default
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-7"
  })), showImage && /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md d-flex"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _imageHeaderConsumer.default
  })))));
};
var _default = SVBConsumerHeader;
exports.default = _default;